require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-cam-minges-wins-executive-leadership-luminary-award-from-credit-union-times.json") })
        }
      }, "path---es-articles-cam-minges-wins-executive-leadership-luminary-award-from-credit-union-times");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-cam-minges-wins-executive-leadership-luminary-award-from-credit-union-times!./.cache/json/es-articles-cam-minges-wins-executive-leadership-luminary-award-from-credit-union-times.json
// module id = 2042
// module chunks = 231608221292675